import { SortIcon } from 'components/icons/SortIcon';
import { SortIconDown } from 'components/icons/SortIconDown';
import { SortIconUp } from 'components/icons/SortIconUp';

type SortingIconProps = {
  currentHeading: string;
  selectedHeading: string;
  isSorted: boolean;
};

export const SortingIcon = ({
  selectedHeading,
  currentHeading,
  isSorted,
}: SortingIconProps) => {
  if (selectedHeading !== currentHeading) {
    return <SortIcon />;
  }
  if (isSorted && selectedHeading === currentHeading) {
    return <SortIconUp />;
  }
  if (!isSorted && selectedHeading === currentHeading) {
    return <SortIconDown />;
  }

  return <SortIcon />;
};
